import React from "react";

import Sidebar from "../Navbar";

const Projects = () => (
  <div className="flex flex-row">
    <Sidebar />
    <div className="mx-10 mt-10">
      <h1 className="text-3xl font-semibold">Projects</h1>
    </div>
  </div>
);

export default Projects;
